import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturesSection from './components/FeaturesSection';
import SEOContentSection from './components/SEOContentSection';
import ArticleCTASection from './components/ArticleCTASection';
import ArticlesShowcaseSection from './components/ArticlesShowcaseSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturesSection />
        <SEOContentSection />
        <ArticlesShowcaseSection />
        <ArticleCTASection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: 'Sugargoo Spreadsheet 2026 - Ultimate Find Database, Reviews & Shopping Guide',
            description:
              'Discover the latest Sugargoo Spreadsheet updates, product finds, reviews, shipping costs, warehouse guides, coupons, discount codes and complete shopping tutorials.',
            url: 'https://sugargoospread.it.com/',
            isPartOf: {
              '@type': 'WebSite',
              name: 'Sugargoo Spreadsheet Hub',
              url: 'https://sugargoospread.it.com/',
            },
            about: {
              '@type': 'Thing',
              name: 'Sugargoo Spreadsheet',
              description:
                'A comprehensive organized database of product listings for international Sugargoo shoppers.',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: 'Home',
                  item: 'https://sugargoospread.it.com/',
                },
              ],
            },
          }),
        }}
      />
    </>
  );
}